import React from "react";
import PropTypes from "prop-types";
import Pagination from "../Layout/pagination";
import Paper from "@material-ui/core/Paper";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state/index";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import IconButton from "@material-ui/core/IconButton";

import "./styles.css";

function Money(n) {
  var c = 2,
    d = ",",
    t = ".",
    s = n < 0 ? "-" : "",
    i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
}

const ItemLista = (props) => {
  /**
   * nombre : titulo del item
   * descripcion: sub titulo, una linea
   * fecha: seguna linea de sub titulo, timestamp
   * monto: cantidad a la derecha, formateada como moneda
   * opciones: lista de opciones desplegables {nombre: string, handler: func}
   * onClick: click en cualquier lugar del item
   */
  return (
    <div
      onClick={props.onClick}
      className="hoverWhite"
      style={{ padding: "12px 23px", marginBottom: "8px", cursor: "pointer" }}
    >
      {props.imagen !== undefined && (
        <img
          alt=""
          style={{
            backgroundColor: "#000000",
            float: "left",
            width: "40px",
            height: "40px",
            marginRight: "16px",
            marginBottom: "16px",
            borderRadius: "100%",
          }}
        />
      )}
      <div style={{ fontFamily: "Roboto", fontSize: "16px" }}>{props.nombre}</div>
      <div style={{ fontFamily: "Roboto", fontSize: "14px", fontWeight: "300" }}>
        {props.descripcion}
      </div>
      {props.fecha !== undefined && (
        <div style={{ fontFamily: "Roboto", fontSize: "14px", fontWeight: "300" }}>
          {props.fecha}
        </div>
      )}
      {props.monto !== undefined && (
        <div
          style={{
            float: "right",
            fontWeight: "normal",
            position: "relative",
            bottom: "22px",
            fontFamily: "Roboto",
            fontSize: "16px",
          }}
        >
          {"$" + Money(props.monto)}
        </div>
      )}
      {props.opciones !== undefined && (
        <div
          style={{
            float: "right",
            fontWeight: "normal",
            position: "relative",
            bottom: "22px",
            fontFamily: "Roboto",
            fontSize: "16px",
          }}
        >
          <PopupState variant="popover" popupId={"nuevo-usuario-menu"}>
            {(popupState) => (
              <React.Fragment>
                <IconButton style={{ bottom: "30px" }} {...bindTrigger(popupState)}>
                  <MoreVertIcon />
                </IconButton>
                <Menu {...bindMenu(popupState)}>
                  {props.opciones.map((x) => {
                    return (
                      <MenuItem
                        key={x.nombre}
                        onClick={(...args) => {
                          x.handler(...args);
                          popupState.close(...args);
                        }}
                      >
                        {x.nombre}
                      </MenuItem>
                    );
                  })}
                </Menu>
              </React.Fragment>
            )}
          </PopupState>
        </div>
      )}
    </div>
  );
};

class ListaPaginada extends React.Component {
  render() {
    return (
      <Paper style={{ backgroundColor: "#FFFBFB" }}>
        <div>
          <div
            style={{
              height: "40px",
              marginBottom: "15px",
              borderBottomStyle: "solid",
              borderBottomWidth: "1px",
              borderBottomColor: "#9B9B9B",
            }}
          >
            <div
              style={{
                position: "relative",
                left: "10px",
                fontFamily: "Roboto",
                fontSize: "20px",
                fontWeight: 500,
                top: "7px",
              }}
            >
              {this.props.titulo}
            </div>
          </div>
          <div style={{ height: "340px", overflowX: "hidden", overflowY: "hidden" }}>
            {this.props.carritos.result &&
              this.props.carritos.result.map((x) => (
                <ItemLista
                  key={x.idPedido || x.id}
                  onClick={() => {
                    this.props.handleOpenModal && this.props.handleOpenModal(x);
                  }}
                  {...this.props.mapToItem(x)}
                />
              ))}
          </div>
        </div>
        <Pagination
          handleOnChange={this.props.handleOnPagination}
          page={this.props.carritos.currentPage + 1 || 0}
          totalPages={this.props.carritos.totalObjects !== 0 ? this.props.carritos.totalPages : 0}
        />

        {/** modales especificos */}
        {this.props.tipo === "carritos" && (
          <Dialog
            disableBackdropClick={true}
            fullWidth={true}
            maxWidth={"sm"}
            open={this.props.openModal}
            onClose={this.props.handleOnCloseModal}
          >
            <div style={{ width: "100%", padding: "12px" }}>
              {this.props.pedido && (
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "90%" }}
                      label="Cliente"
                      defaultValue={this.props.pedido.razonSocial}
                      margin="normal"
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "90%" }}
                      label="Usuario"
                      defaultValue={this.props.pedido.usuario}
                      margin="normal"
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "90%" }}
                      label="Monto"
                      defaultValue={Money(this.props.pedido.precioFinal)}
                      margin="normal"
                      InputProps={{ readOnly: true, style: { direction: "rtl" } }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "90%" }}
                      label="Fecha"
                      defaultValue={this.props.pedido.fecha}
                      margin="normal"
                      InputProps={{ readOnly: true, style: { direction: "rtl" } }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "90%" }}
                      label="Telefono"
                      defaultValue={this.props.pedido.telefono}
                      margin="normal"
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "90%" }}
                      label="Correo"
                      defaultValue={this.props.pedido.correo}
                      margin="normal"
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                </Grid>
              )}
              <div style={{ textAlign: "left", marginTop: "44px", paddingLeft: "55%" }}>
                <Button
                  style={{ marginRight: "12px" }}
                  className="btnSecundario"
                  onClick={this.props.handleCloseModal}
                >
                  Cancelar
                </Button>
                <Button
                  className="btnPrincipal"
                  onClick={() => {
                    this.props.handleEliminar(this.props.pedido.idPedido);
                  }}
                >
                  Eliminar
                </Button>
              </div>
            </div>
          </Dialog>
        )}

        {this.props.tipo === "usuariosNuevos" && (
          <Dialog
            disableBackdropClick={true}
            fullWidth={true}
            maxWidth={"sm"}
            open={this.props.openModal}
            onClose={this.props.handleOnCloseModal}
          >
            <div style={{ width: "100%", padding: "12px" }}>
              <div style={{ verticalAlign: "center", textAlign: "center", paddingTop: "30px" }}>
                <div>{"Esta por habilitar al usuario " + this.props.pedido.nombreUsuario}</div>
              </div>
              <div style={{ textAlign: "left", marginTop: "44px", paddingLeft: "55%" }}>
                <Button
                  style={{ marginRight: "12px" }}
                  className="btnSecundario"
                  onClick={this.props.handleCloseModal}
                >
                  Cancelar
                </Button>
                <Button
                  className="btnPrincipal"
                  onClick={() => {
                    this.props.handleEliminar(this.props.pedido.idPedido);
                  }}
                >
                  Habilitar
                </Button>
              </div>
            </div>
          </Dialog>
        )}
      </Paper>
    );
  }
}

ListaPaginada.propTypes = {
  carritos: PropTypes.array.isRequired,
  mapToItem: PropTypes.func,
  titulo: PropTypes.func.isRequired,
  handleOnPagination: PropTypes.func.isRequired,
  openModal: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  handleOpenModal: PropTypes.func,
  pedido: PropTypes.object,
  resultadoAccion: PropTypes.bool,
  handleEliminar: PropTypes.func,
  mensajeAccion: PropTypes.string,
  tipo: PropTypes.string,
};

export default ListaPaginada;
